export default __webpack_public_path__ + "static/videovratnik-value-7f916490681b1a07590810e92ff0cbcf.png";